import React from 'react';

import { Paper } from 'material-ui';

import tcIcon from './icon';

const CreditCard = ({ cardType, cardNumber, cardExpYear, cardExpMonth, nameOnCard }) => {
  const cardIcon = (brand) => {
    switch (brand.toLowerCase()) {
      case 'american express':
        return 'amex';
      case 'visa':
      case 'mastercard':
      case 'discover':
        return brand.toLowerCase();
      default:
        return '';
    }
  };

  return (<Paper style={{ backgroundColor: '#fbfbfb', borderRadius: '18px', boxShadow: 'rgba(0, 0, 0, 0.58) 0px 0 1px', padding: '20px 30px', margin: '0 auto' }}>
    <p style={{ textAlign: 'right', margin: '-15px 0 15px 0' }}><tcIcon className={`tc-icon-${cardIcon(cardType)}`} style={{ fontSize: '50px' }}/></p>
    <p style={{ fontSize: '18px', fontWeight: 300, letterSpacing: '5px', textAlign: 'center' }}>xxxx xxxx xxxx {cardNumber}</p>
    <p style={{ display: 'inline-block', margin: 0, textAlign: 'left' }}>{nameOnCard}</p>
    <p style={{ display: 'inline-block', float: 'right', margin: 0, textAlign: 'right' }}> {cardExpMonth} / {cardExpYear.toString().slice(-2)}</p>
  </Paper>);
};

export default CreditCard;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/CreditCard.jsx